import React from "react";

export default class MyForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: "",
    };
  }

  render() {
    const { status } = this.state;
    return (
      <form
        onSubmit={this.submitForm}
        action="https://formspree.io/f/xoqroodw"
        method="POST"
      >
        <label style={{ color: "#fff" }}>Email:</label>
        <input
          type="email"
          name="email"
          placeholder="Enter E-mail ID"
          required
        />
        <label style={{ color: "#fff" }}>Specialization:</label>
        <input
          type="text"
          name="message"
          placeholder="What you are specialized in"
          required
        />
        <label style={{ color: "#fff" }}>Message:</label>
        <textarea
          type="text"
          name="message"
          id="item04"
          placeholder="Your message"
        />

        {status === "SUCCESS" ? (
          <p style={{ color: "#fff", fontWeight: "300" }}>
            Your response is received!
          </p>
        ) : (
          <button
            className="rn-button-style--2 btn-solid"
            type="submit"
            value="submit"
            name="submit"
            id="mc-embedded-subscribe"
          >
            Submit
          </button>
        )}
        {status === "ERROR" && (
          <p style={{ color: "#fff" }}>Ooops! There was an error.</p>
        )}
      </form>
    );
  }

  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }
}
